import styled from '@emotion/styled';
import React from 'react';

const Overlay = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  circle {
    fill: rgba(255, 255, 255, 0);
    stroke: rgba(255, 255, 255, 1);
    transition: fill 175ms ease-in-out;
  }

  path {
    stroke: rgba(255, 255, 255, 1);
    transition: 175ms ease-in-out;
    transition-property: stroke, fill;
  }

  path + path {
    stroke: none;
    opacity: 0;
    transition: opacity 175ms ease-in-out;
  }

  &:hover circle {
    fill: rgba(255, 255, 255, 1);
  }

  &:hover path + path {
    opacity: 1;
  }
`;

export const PlayButton = (props: any) => {
  return (
    <Overlay {...props}>
      <svg
        width="124"
        height="124"
        viewBox="0 0 124 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="61.8" cy="61.8" r="60.8" strokeWidth="1.6" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.9599 95.6422v-68.304l51.8322 34.152-51.8322 34.152z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.9599 95.6422v-68.304l51.8322 34.152-51.8322 34.152z"
          fill="url(#paint0_linear)"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="10.8079"
            y1="18.4981"
            x2="10.8079"
            y2="104.482"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2F6183" />
            <stop offset="1" stopColor="#15324C" />
          </linearGradient>
        </defs>
      </svg>
    </Overlay>
  );
};
